import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import firebase from 'firebase/app'
import VueFirestore from 'vue-firestore'
import { db } from './firebase.config'
import '@firebase/auth'
import Buefy from 'buefy'
import vueHeadful from 'vue-headful'
import VueAnalytics from 'vue-analytics'
import wysiwyg from 'vue-wysiwyg'
import { firestorePlugin } from 'vuefire'

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-74432423-4',
  router,
  ecommerce: {
    enabled: true
  },
  debug: {
    enable: !isProd,
    sendHitTask: isProd
  }
})

window.store = store

Vue.use(VueFirestore)
Vue.use(firestorePlugin)
Vue.component('vue-headful', vueHeadful)
Vue.use(wysiwyg, {})

// Frameworks
/* Responsive */
Vue.use(Buefy, {
  defaultIconPack: 'fa'
})

Vue.config.productionTip = !isProd

const unsubscribe = firebase
  .auth()
  .onAuthStateChanged((user) => {
    new Vue({
      router,
      store,
      render: h => h(App),
      created () {
        if (user) {
          store.dispatch('autoSignIn', user)
        } else {
          store.dispatch('logout')
        }
      },
      data () {
        return {
          payments: []
        }
      },
      firestore () {
        var obj = {
          novels: db.collection('novels')
        }
        if (user) {
          if (user.email) {
            obj['payments'] = db.collection('payments').where('user_email', '==', user.email)
          } else {
            obj['payments'] = db.collection('payments').where('uid', '==', user.uid)
          }
        }
        return obj
      },
      computed: {
        isImmortal () {
          if (user) {
            var immortal = this.payments
              .filter(payment => payment.status === 'completed')
              .find(payment => payment['subscription_plan_id'] === 'immortal')
            if (immortal) {
              return true
            }
          }
          return false
        }
      }
    }).$mount('#app')

    unsubscribe()
  })
